module.exports = __webpack_public_path__ + "static/media/16.db00ab8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kenya/16.jpg
// module id = 492
// module chunks = 0